export const SOCKET_AUTH_PREFIX = 'clientSessionId_';

export const APP_API_VERSION_1 = '/v1';

export const DESKTOP_MIN_WIDTH = 750;
